import {
  ChangeEvent,
  FC,
  SyntheticEvent,
  useEffect,
  useRef,
  useState,
} from "react";
import { InputField } from "@/components/common/input";
import { FormFieldName } from "@/pages/quiz/base/questions/contactField/contactFieldsCPL";

interface InputFieldDisplayProps {
  registerField: (name: FormFieldName) => {
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onBlur: (e: SyntheticEvent<HTMLInputElement>) => void;
    error: string | boolean;
    name: string;
  };
  values: Record<string, string>;
  onBackPressed: () => void;
  onResendCode: () => Promise<void>;
}

const RESEND_COOLDOWN = 60;

const ContactsVerify: FC<InputFieldDisplayProps> = ({
  onBackPressed,
  onResendCode,
  registerField,
  values,
}) => {
  const resendCooldownTimer = useRef<number | null>();
  const [cooldownSecondsLeft, setCooldownSecondsLeft] =
    useState(RESEND_COOLDOWN);
  const isNewCodeSent = cooldownSecondsLeft !== RESEND_COOLDOWN;

  useEffect(() => {
    if (cooldownSecondsLeft <= 0) {
      setCooldownSecondsLeft(RESEND_COOLDOWN);

      if (resendCooldownTimer.current) {
        clearInterval(resendCooldownTimer.current);
        resendCooldownTimer.current = null;
      }
    }
  }, [cooldownSecondsLeft]);

  const onGetNewCode = async () => {
    try {
      await onResendCode();

      setCooldownSecondsLeft(RESEND_COOLDOWN);

      resendCooldownTimer.current = window.setInterval(() => {
        setCooldownSecondsLeft((v) => v - 1);
      }, 1000);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className=" flex flex-col-reverse items-center	 w-full justify-center gap-4 desktop:p-8">
      <div className="text-center max-w-[100%] w-[480px] flex-col flex gap-2">
        <p className="section-title text-lg">
          We sent you a confirmation code at {values["phone"]}
        </p>

        <InputField
          {...registerField("verificationCode")}
          label="Confirmation code"
          type="verifyCode"
          required
        />

        <div className="text-left mt-2 text-base">
          {isNewCodeSent ? (
            <span>
              We sent you another code. You'll be able to try again in{" "}
              {cooldownSecondsLeft} seconds
            </span>
          ) : (
            <>
              <span>Didn't get the code? </span>
              <span
                onClick={onGetNewCode}
                className="underline cursor-pointer text-blue-2"
              >
                Get new code
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactsVerify;
